import { render } from "./DisputePage.vue?vue&type=template&id=f0aa67ea&scoped=true"
import script from "./DisputePage.vue?vue&type=script&lang=js"
export * from "./DisputePage.vue?vue&type=script&lang=js"

import "./DisputePage.vue?vue&type=style&index=0&id=f0aa67ea&lang=css"
import "./DisputePage.vue?vue&type=style&index=1&id=f0aa67ea&lang=css"
import "./DisputePage.vue?vue&type=style&index=2&id=f0aa67ea&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0aa67ea"]])

export default __exports__